import FormDrawer from "components/__new/common/form-drawer";
import successGif from "assets/images/icons/success-green.gif";
import Maybe from "components/__new/common/Maybe";
import { ButtonLoader } from "components/__new/common/form";

/**
button1={{
    "text": "",
    "class": "",
    "click": "",
}}
*/

export const ModalAlert = (props) => {
    const {isOpenModalAlert, setIsOpenModalAlert, subText, closeDialog} = props;
    const {button1, button2, button3} = props;

    const successImg = props.successImg || successGif;
    const successText = props.successText || "Successful";
    const dismissText = props.dismissText || "Dismiss";

    const dismiss = () => {
        if (props.submit !== undefined){
            props.submit();
        }
        else{
            setIsOpenModalAlert(false)
        }
    }

    return (
        <FormDrawer display="center" size="sm" isOpen={isOpenModalAlert} setIsOpen={setIsOpenModalAlert} closeDialog={closeDialog}>
            <div className="p-12 max-w-sm">
                <div className="w-60 h-60 mx-auto flex items-center justify-center">
                    <img src={successImg} alt="Success" className="object-contain" />
                </div>
                <div className="mt-0 text-xl text-center">
                    {successText}
                </div>
                <Maybe condition={subText !== undefined}>
                    <div className="mt-2 text-fade text-center">
                        {subText}
                    </div>
                </Maybe>
                
                <div className="mt-6">
                    <Maybe condition={button1 !== undefined}>
                        <ButtonLoader type="button" loading={button1?.loading || false} onClick={button1?.click} className={button1?.class + " mb-2"}>
                            {button1?.text}
                        </ButtonLoader>
                    </Maybe>

                    <Maybe condition={button2 !== undefined}>
                        <ButtonLoader type="button" loading={button2?.loading || false} onClick={button2?.click} className={button2?.class + " mb-2"}>
                            {button2?.text}
                        </ButtonLoader>
                    </Maybe>

                    <Maybe condition={button3 !== undefined}>
                        <ButtonLoader type="button" loading={button3?.loading || false} onClick={button3?.click} className={button3?.class + " mb-2"}>
                            {button3?.text}
                        </ButtonLoader>
                    </Maybe>

                    <Maybe condition={props.dismissText !== undefined && props.dismissText !== null}>
                        <button type="button" onClick={dismiss} className="btn btn-block btn-transparent-primary">
                            {dismissText}
                        </button>
                    </Maybe>
                </div>
            </div>
        </FormDrawer>
    )
}

export default ModalAlert;